import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import * as api from '../../api/account'
import { useAuth } from '../../context/AuthContext'
import { Button, ErrorText, Field, SectionTitle, inputClass } from './ui'

const DangerSection = ({ profile }) => {
  const { refresh } = useAuth()
  const navigate = useNavigate()
  const [potwierdzenie, setPotwierdzenie] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const usun = async (e) => {
    e.preventDefault()
    setError('')
    setBusy(true)
    const res = await api.deleteAccount(potwierdzenie)
    setBusy(false)
    if (!res.ok) { setError(res.error); return }
    await refresh()
    navigate('/', { replace: true })
  }

  return (
    <form onSubmit={usun}>
      <SectionTitle>Usunięcie konta</SectionTitle>

      <div className="mb-5 flex gap-2.5 rounded-lg bg-red-50 border border-red-100 p-3.5">
        <ExclamationTriangleIcon className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
        <div className="text-sm text-red-800 leading-6">
          <p className="font-semibold mb-1">Tej operacji nie da się cofnąć.</p>
          <p>
            Usuniemy Twoje dane osobowe, obserwowane produkty i zapisane zestawy.
            Zachowamy wyłącznie zapis o udzielonych zgodach — bez powiązania z Tobą —
            bo jest nam potrzebny jako dowód, że zostały udzielone zgodnie z prawem.
          </p>
        </div>
      </div>

      {/* Przepisanie adresu zamiast jednego kliknięcia: to działanie
          nieodwracalne, a przycisk „Usuń konto" bywa klikany przez pomyłkę. */}
      <div className="max-w-md">
        <Field
          label="Aby potwierdzić, wpisz swój adres e-mail"
          hint={profile.email}
        >
          <input
            type="email"
            className={inputClass}
            value={potwierdzenie}
            onChange={(e) => setPotwierdzenie(e.target.value)}
            disabled={busy}
            autoComplete="off"
            placeholder={profile.email}
          />
        </Field>
      </div>

      <div className="mt-4"><ErrorText>{error}</ErrorText></div>

      <div className="mt-5">
        <Button
          type="submit"
          variant="danger"
          busy={busy}
          disabled={potwierdzenie.trim().toLowerCase() !== profile.email.toLowerCase()}
        >
          Trwale usuń moje konto
        </Button>
      </div>
    </form>
  )
}

export default DangerSection
